var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"header-navigation-link",attrs:{"href":_vm.href}},[_vm._v(_vm._s(_vm.title)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }